/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Status_DescriptionInputs */



/**
* | output |
* | --- |
* | "Turn off to pause automated monitoring and alerts." |
*
* @param {Compliance_Copilot_Status_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_status_description = /** @type {((inputs?: Compliance_Copilot_Status_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Status_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausschalten, um die automatische Überwachung und Warnungen zu pausieren.")
	return /** @type {LocalizedString} */ ("Turn off to pause automated monitoring and alerts.")
});